import { useTransferMoneyContext } from './useTransferMoneyContext';
import { TabSlug } from '../../../AccountPerformanceReporting/types';

export const useNavigateToTransactions = () => {
  const { clientId, accountId } = useTransferMoneyContext();

  return {
    navigateToTransactions() {
      ADV.util.Router.go2('AccountPerformanceReporting', {
        clientId,
        groupId: '',
        accountId,
        tabSlug: TabSlug.Activity,
        isApex: true,
      });
    },
  };
};
